import React from 'react'
import ApiUrl from '../../../configTools/apiUrl'
import { Link } from 'react-router-dom'

const CollectionItem = ({Product}) => {
  return (
    <Link to={'/ncollection/'+Product.id}>
        <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+Product.image})`}}>
            <div className='public_home_product_grid_1_products_item_overlay'>
                <div className='public_home_product_grid_1_products_item_overlay_price'>
                    <p>
                        {Product.title}
                    </p>
                </div>
            </div>
        </div>
    </Link>
  )
}

export default CollectionItem
